import gql from 'graphql-tag'
import getDomain from 'App/helpers/websites/getDomain'
import WebsiteIdContext from 'App/Pages/WebsiteAdmin/WebsiteIdContext'
import {useContext} from 'react'
import useInitialDataOrQuery from './useInitialDataOrQuery'
import getQueryParam from './useURLState/getQueryParam'

// para que se guarde solo al cargar la pagina y quede asi la variable para siempre
const queryWebsiteId = getQueryParam({location: window.location, key: 'websiteId'})

export default function useWebsiteId() {
  const adminWebsiteId = useContext(WebsiteIdContext)
  const domain = getDomain()

  const {website} = useInitialDataOrQuery({
    query: gql`
      query getWebsiteIdFromDomain_cached($domain: String) {
        website(domain: $domain) {
          _id
          domain
          logo {
            _id
            url
          }
        }
      }
    `,
    variables: {domain},
    fetchPolicy: 'cache-first',
    omit: !domain || adminWebsiteId || queryWebsiteId
  })

  if (adminWebsiteId) return adminWebsiteId
  if (queryWebsiteId) return queryWebsiteId
  if (!domain) return null
  if (!website) return null

  return website._id
}
